@if (!inputService.hidden && inputService.formInputDefinition && inputService.control) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field class='time-input-field' [appearance]='inputService.inputConfig.appearence' [ngClass]='$safeNavigationMigration(inputService?.formInputDefinition?.inputConfig?.customCssClass)'>
      <mat-label>{{inputService.computedTitle | translate}}</mat-label>
      <input [readonly]='readOnly' autocomplete="off" type='time' matInput [placeholder]="(inputService.inputConfig.placeholder || '') | translate" [formControlName]='inputService.formControlKey'>
      @if (!inputService.inputConfig.readOnly && !inputService.formInputDefinition.disallowNull && inputService.inputConfig.clearable && inputService.control.value) {
        <mat-icon matSuffix style='cursor: pointer;' (click)='inputService.control.setValue(null)'>close</mat-icon>
      }
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint | translate}}</mat-hint>
      }
      @if (!inputService.control.valid) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}